import React from 'react';
import MainMenuItem from '@/Shared/MainMenuItem';
import { usePage } from '@inertiajs/inertia-react';

export default ({ className }) => {
  const {auth: {user}} = usePage().props;

  return (
    <div className={className}>
      {/*<MainMenuItem text="Dashboard" link="dashboard" icon="dashboard" />*/}
      {/*<MainMenuItem text="Organizations" link="organizations" icon="office" />*/}
      {/*<MainMenuItem text="Contacts" link="contacts" icon="users" />*/}
      {/*<MainMenuItem text="Reports" link="reports" icon="printer" />*/}

      <MainMenuItem text="Added Coupons" link="added.coupons" iconSrc={'/images/menu/coupon.svg'} iconAlt={'coupons'} />
      {user.role.role !== 'User' && <MainMenuItem text="Published Coupons" link="public.coupons" iconSrc={'/images/menu/published_coupon.svg'} iconAlt={'coupons'} />}
      <MainMenuItem text="Added Merchants" link="added.merchants" iconSrc={'/images/menu/merchant.svg'} iconAlt={'merchants'} />
      {user.role.role !== 'User' && <MainMenuItem text="Public Merchants" link="public.merchants" iconSrc={'/images/menu/published_merchant.svg'} iconAlt={'merchants'} />}
      {user.role.role !== 'User' && <MainMenuItem text="Categories" link="categories" iconSrc={'/images/menu/categories.svg'} iconAlt={'categories'} />}
      {user.role.role !== 'User' && <MainMenuItem text="Banners" link="banners" iconSrc={'/images/menu/flipboard.svg'} iconAlt={'banners'} />}
      {user.role.role !== 'User' && <MainMenuItem text="Static Pages" link="static-page" iconSrc={'/images/menu/static-page.svg'} iconAlt={'static-page'} />}
      {(user.role.role !== 'User' && user.role.role !== 'Admin') && <MainMenuItem text="Main Settings" link="main-settings" iconSrc={'/images/menu/main-settings.svg'} iconAlt={'main-settings'} />}
      {/*<MainMenuItem text="Merchants" link="merchants" icon="dashboard" />*/}
      {/*<MainMenuItem text="Categories" link="categories" icon="dashboard" />*/}
    </div>
  );
};
